import React from 'react'
import type { CommunityLinkPreview } from '../services/linkPreviewService'

type Props = {
  preview: CommunityLinkPreview
}

export function CommunityLinkPreviewCard({ preview }: Props) {
  if (!preview) return null

  if (preview.type === 'tradingview-chart') {
    return (
      <TradingViewPreviewCard preview={preview} />
    )
  }

  return null
}

function TradingViewPreviewCard({ preview }: { preview: CommunityLinkPreview }) {
  const [open, setOpen] = React.useState(false)

  if (!preview.imageUrl) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group relative h-16 w-16 overflow-hidden rounded-md border border-[#2a2a2a] bg-[#111111] hover:border-[#38bdf8]/70"
        title={preview.title}
      >
        <img
          src={preview.imageUrl}
          alt={preview.title}
          className="h-full w-full object-cover transition-transform duration-150 group-hover:scale-105"
          loading="lazy"
        />
      </button>

      {open && (
        <div className="fixed inset-0 z-[210000] flex items-center justify-center bg-black/80 px-4 py-6">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="absolute right-4 top-4 rounded-full bg-black/60 px-3 py-1 text-xs font-medium text-white hover:bg-black/80"
          >
            Fechar
          </button>
          <div className="max-h-[90vh] max-w-[90vw]">
            <img
              src={preview.imageUrl}
              alt={preview.title}
              className="h-full w-full rounded-lg object-contain shadow-2xl"
            />
          </div>
        </div>
      )}
    </>
  )
}
